import { render, staticRenderFns } from "./StartpageView.vue?vue&type=template&id=637eb9b7"
import script from "./StartpageView.vue?vue&type=script&lang=ts"
export * from "./StartpageView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports